"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _customPage = require("@/api/customPage");
var _addBanner = _interopRequireDefault(require("./addBanner.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    addBanner: _addBanner.default
  },
  data: function data() {
    return {
      puzzleList: [],
      searchStyle: '',
      realObj: {
        0: {
          text: '未开始',
          color: '#E6A23C',
          src: require('@/assets/pcl2.png')
        },
        1: {
          text: '上线中',
          color: '#67C23A',
          src: ''
        },
        2: {
          text: '已下线',
          color: '#F56C6C',
          src: require('@/assets/pcl1.png')
        }
      },
      componentCode: '',
      componentSubcode: '',
      id: '',
      dialogVisible: false,
      popTitle: '',
      title: '',
      status: '',
      options: [{
        label: '启用',
        value: 1
      }, {
        label: '停用 ',
        value: 0
      }],
      tableData: []
    };
  },
  methods: {
    saveIt: function saveIt() {
      var _this = this;
      this.$confirm('是否确认保存 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.saveOrUpdateBanner)({
          moduleId: _this.id,
          searchStyle: _this.searchStyle
        }).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this.findList();
          _this.$emit('refresh', _this.id);
        });
      });
    },
    needRefresh: function needRefresh() {
      // 通知组件刷新（单个组件）
      this.findList();
      this.$emit('refresh', this.id);
    },
    del: function del(val) {
      var _this2 = this;
      console.log(val);
      //   deleteBanner({
      //     bannerId:val.bannerId
      //   })
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.deleteBanner)({
          bannerId: val.bannerId
        }).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this2.findList();
          _this2.$emit('refresh', _this2.id);
        });
      });
    },
    onClose: function onClose() {
      this.title = '';
      this.status = '';
      this.tableData = [];
      this.dialogVisible = false;
    },
    add: function add() {
      this.$refs.addBanner.open({
        name: '新增',
        type: 'add',
        moduleId: this.id,
        mType: this.componentCode === 'bannerWithPuzzle' || this.componentCode === 'verticalBannerWithPuzzle' ? '2' : '',
        componentCode: this.componentCode
      });
    },
    detail: function detail(val, text) {
      if (text === 'noNeed') {
        this.$refs.addBanner.open({
          name: '编辑',
          type: 'upDate',
          moduleId: this.id,
          bannerId: val.bannerId
        });
      } else {
        this.$refs.addBanner.open({
          name: '编辑',
          type: 'upDate',
          moduleId: this.id,
          bannerId: val.bannerId,
          componentCode: this.componentCode
        });
      }
    },
    open: function open(data) {
      console.log(data);
      this.popTitle = data.name;
      this.componentSubcode = data.componentSubcode;
      this.componentCode = data.componentCode;
      this.id = data.id;
      this.findList();
      this.dialogVisible = true;
    },
    findList: function findList() {
      var _this3 = this;
      (0, _customPage.moduleDetail)({
        moduleId: this.id,
        bannerName: this.title,
        status: this.status
      }).then(function (res) {
        console.log(res);
        if (_this3.componentCode === 'bannerWithPuzzle' || _this3.componentCode === 'verticalBannerWithPuzzle') {
          _this3.tableData = res.data.carouselBanner;
          _this3.puzzleList = res.data.banner;
        } else {
          _this3.tableData = res.data.banner;
        }
        if (_this3.componentCode === 'topSearch') {
          _this3.searchStyle = res.data.searchStyle * 1;
        }
      });
    },
    clear: function clear() {
      this.title = '';
      this.status = '';
      this.findList();
    },
    search: function search() {
      this.findList();
    }
  }
};